import React from "react";

export type ColorMode = "light" | "dark";

const STORAGE_KEY = "hmis-color-mode";

export const getStoredColorMode = (): ColorMode => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyColorMode = (mode: ColorMode) => {
  document.documentElement.setAttribute("data-theme", mode);
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore private-mode storage failures
  }
};

type ColorModeContextValue = {
  mode: ColorMode;
  toggleColorMode: () => void;
};

export const ColorModeContext = React.createContext<ColorModeContextValue>({
  mode: "light",
  toggleColorMode: () => {},
});
